export default __webpack_public_path__ + "static/googlestore-a1c76bd642b703703718cb8bbb50b6af.png";